import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { IonicModule } from '@ionic/angular';
import { AzzurroTable, SimpleButtonComponent, TitleContentComponent } from 'ngx-zcs-components';

import { ConnextDetailsComponent } from './connext-details.component';
import { BlockTitleComponent } from '../components/block-title/block-title.component';
import { ConnextDetailsService } from './connext-details.service';

@NgModule({
  declarations: [
    ConnextDetailsComponent,
  ],
  imports: [
    AzzurroTable,
    BlockTitleComponent,
    CommonModule,
    IonicModule,
    MatIconModule,
    MatProgressSpinnerModule,
    TitleContentComponent,
    SimpleButtonComponent
],
  exports: [
    ConnextDetailsComponent,
  ],
  providers: [
    ConnextDetailsService,
  ],
})
export class ConnextDetailsModule { }
